import { Routes } from '@angular/router';
import { TestPage } from './pages/test/test.page';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.routes').then(m => m.mainRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: 'test',
    component: TestPage
  },
  {
    path: 'callback',
    loadComponent: () => import('./pages/callback/callback.page').then(m => m.CallbackPage)
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout-session/logout.page').then(m => m.LogoutPage)
  },
  {
    path: 'sessionclosed',
    loadComponent: () => import('./pages/logout-session/session-closed.page').then(m => m.SessionClosedPage)
  },
    {
    path: 'sessionexpired',
    loadComponent: () => import('./pages/logout-session/session-expired.page').then(m => m.SessionExpiredPage)
  },
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'main/error'
  }
];
